import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const availableLanguages = ['ko', 'en', 'chi', 'hi', 'fr', 'it', 'us', 'es'];

const options = {
  order: ['navigator', 'htmlTag', 'path', 'subdomain'], // This determines the order in which i18next detects the language
  checkWhitelist: true, // This ensures that only languages in the whitelist are considered valid
};

i18n
  .use(Backend) // This loads translations from the backend (usually your server or a CDN)
  .use(LanguageDetector) // This detects the language based on user settings, browser language, etc.
  .use(initReactI18next) // Integrates i18next with React
  .init({
    fallbackLng: 'en', // Default language if a translation is not available
    debug: true, // Helps to log the debug information in the console (set to false in production)
    whitelist: availableLanguages, // Whitelisted languages to ensure no other languages are used
    detection: options, // Configuration options for language detection
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path where the translation JSON files are located
    },
    interpolation: {
      escapeValue: false, // React escapes values by default, so we disable escaping here
    },
  });

export default i18n;
